import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "components/layout";
import {
  ArrowLeftIcon2,
  ArrowRightIcon2,
  HeartFillIcon,
  HeartIcon,
  ShareIcon,
} from "assets/icons";
import { Hot } from "sections";

function HotDetail() {
  const [isFavorite, setIsFavorite] = useState(false);
  const tags = ["Offers"];

  const termsCondition = [
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing",
  ];

  const headActions = () => (
    <div className="flex items-center gap-2 lg:gap-3">
      <button
        onClick={() => setIsFavorite(!isFavorite)}
        className="h-8 lg:h-12 w-8 lg:w-12 rounded-[4px] lg:border-[1px] border-primary-700 flex items-center justify-center"
      >
        <span
          className={`h-[18px] w-[18px] ${
            isFavorite ? "text-primary-700" : ""
          }`}
        >
          {isFavorite ? <HeartFillIcon /> : <HeartIcon />}
        </span>
      </button>
      <button className="h-8 lg:h-12 w-8 lg:w-12 rounded-[4px] lg:border-[1px] border-primary-700 flex items-center justify-center">
        <ShareIcon />
      </button>
    </div>
  );

  return (
    <Layout showMobileHeader={false} showBottomTab={false}>
      <div className="w-full flex justify-center">
        <div className="w-full max-w-8xl margins">
          <div className="mt-10 mb-8 hidden lg:flex items-center gap-2">
            <div className="text-sm text-primary-700 font-semibold">Home</div>
            <ArrowRightIcon2 />
            <div className="text-sm text-[#112211] font-semibold">
              Spend & Redeem with any purchase of RM15
            </div>
          </div>

          <div className="w-full flex lg:hidden items-center py-5">
            <Link className="flex-1 flex items-center gap-2 text-sm text-black font-semibold">
              <span className="h-3 w-3">
                <ArrowLeftIcon2 />
              </span>
              Back
            </Link>
            {headActions()}
          </div>

          <div className="w-full hidden lg:flex justify-between mb-10">
            <div className="flex flex-col max-w-[800px]">
              <div className="text-[20px] lg:text-[32px] leading-7 lg:leading-10 text-primary-[#263238] font-semibold mb-6">
                Spend & Redeem with any purchase of RM15
              </div>
              <div className="items-center gap-5 hidden lg:flex">
                {tags.map((tag, index) => (
                  <div className="text-base font-medium bg-[#FFD7D180] p-1">
                    #{tag}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col min-w-fit">
              <div className="min-w-fit text-sm lg:text-lg text-medium text-primary-700 mb-4">
                617 Reviews
              </div>
              <span className="hidden lg:flex items-center">
                {headActions()}
              </span>
            </div>
          </div>

          <div className="w-full flex flex-col lg:flex-row gap-4 lg:gap-12 mb-8 lg:mb-[60px]">
            <div
              className="bgImage !h-[300px] md:!h-[380px] lg:!h-[500px] min-w-full lg:min-w-[500px] lg:max-w-[520px] rounded-[30px]"
              style={{
                backgroundImage: `url(/images/hot-4.png)`,
              }}
            />
            <div className="flex flex-col">
              <div className="text-[20px] lg:leading-7 lg:text-2xl font-semibold text-black">
                Spend & Redeem with any purchase of RM15
              </div>
              <div className="flex flex-col py-5 lg:py-8">
                <div className="text-base text-[#858585]">
                  Minimum spend - RM15
                </div>
                <div className="text-base text-[#858585]">
                  Validity Date - 15 May 2024 to 30 May 2024
                </div>
              </div>
              <div className="text-base md:text-[20px] leading-6 text-[#112211] font-semibold mb-4">
                Terms & Conditions
              </div>
              <div className="w-full flex flex-col gap-2.5 mb-0 lg:mb-8">
                {termsCondition.map((item, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <div className="h-1 min-w-1 mt-3 bg-[#112211]/70 rounded-full" />
                    <div className="text-base sm:text-lg text-[#112211]/70">
                      {item}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Hot className="mb-[60px]" />
        </div>
      </div>
    </Layout>
  );
}

export default HotDetail;
